export const EXPORT_COMMANDS_REPORT = 'EXPORT_COMMANDS_REPORT';
export const EXPORT_COMMANDS_REPORT_SUCCESS = 'EXPORT_COMMANDS_REPORT_SUCCESS';
export const EXPORT_COMMANDS_REPORT_FAILURE = 'EXPORT_COMMANDS_REPORT_FAILURE';

export const exportCommandsReport = data => ({
  type: EXPORT_COMMANDS_REPORT,
  payload: data
});

export const EXPORT_RETURN_VOUCHERS_REPORT = 'EXPORT_RETURN_VOUCHERS_REPORT';
export const EXPORT_RETURN_VOUCHERS_REPORT_SUCCESS =
  'EXPORT_RETURN_VOUCHERS_REPORT_SUCCESS';
export const EXPORT_RETURN_VOUCHERS_REPORT_FAILURE =
  'EXPORT_RETURN_VOUCHERS_REPORT_FAILURE';

export const exportReturnVouchersReport = data => ({
  type: EXPORT_RETURN_VOUCHERS_REPORT,
  payload: data
});

export const EXPORT_RECEPTIONS_COMPARATIVE = 'EXPORT_RECEPTIONS_COMPARATIVE';
export const EXPORT_RECEPTIONS_COMPARATIVE_SUCCESS =
  'EXPORT_RECEPTIONS_COMPARATIVE_SUCCESS';
export const EXPORT_RECEPTIONS_COMPARATIVE_FAILURE =
  'EXPORT_RECEPTIONS_COMPARATIVE_FAILURE';

export const exportReceptionsComparative = data => ({
  type: EXPORT_RECEPTIONS_COMPARATIVE,
  payload: data
});
